// extracted by mini-css-extract-plugin
export default {"grey-cross":"zLUyy"};